import { render, staticRenderFns } from "./vehicle-table.vue?vue&type=template&id=8b06de26&scoped=true&"
import script from "./vehicle-table.vue?vue&type=script&lang=ts&"
export * from "./vehicle-table.vue?vue&type=script&lang=ts&"
import style0 from "./vehicle-table.vue?vue&type=style&index=0&id=8b06de26&prod&lang=scss&"
import style1 from "./vehicle-table.vue?vue&type=style&index=1&id=8b06de26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b06de26",
  null
  
)

export default component.exports